import React from 'react';
import { ImageModel, LinkModel } from '../../models/globals';
import { PageSection } from '../page-section/PageSection';

interface FinancialAidProps {
    content: string[];
    defaultImage: ImageModel;
    header: string;
    image: ImageModel;
    keyPoints: null;
    link: LinkModel;
    videoUrl: null;
}

const FinancialAid: React.FC<FinancialAidProps> = (props) => {
    return (
        <PageSection
            {...props}
            buttonPropOverrides={{ variant: 'primary' }}
            className="bg-light"
            contentClassName="font-weight-light page-section-content mb-4 text-secondary"
        />
    );
};

export { FinancialAid, FinancialAidProps };
